import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { Rate } from 'antd';

const NewCustomersContent = ({ content }: { content: any }) => {
  if (!content?.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{content.title}</h2>
      {content.desc && <p className={styles.desc}>{content.desc}</p>}
      <div className={styles.cardsList}>
        {content.cards?.map((item: any, index: number) => (
          <div key={item.id || index} className={styles.card}>
            <div className={styles.cardContent}>
              <div className={styles.information}>
                <Image
                  src={item.imgPath || '/images/default-icon.png'}
                  alt={item.title || 'User'}
                  width={48}
                  height={48}
                  className={styles.avatar}
                />
                <div className={styles.userInfo}>
                  <div className={styles.userName}>{item.title}</div>
                  <div className={styles.spacer}></div>
                  <div className={styles.ratingWrapper}>
                    <Rate className={styles.rating} disabled allowHalf value={item.points ? Number(item.points) : 5} />
                  </div>
                </div>
              </div>
              <div className={styles.paragraph}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewCustomersContent;
